// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.product-detail-dialog {
  display: flex;
  flex-direction: column;
  gap: 16px;
  height: 100%;
  min-height: 0;
}

.product-detail-dialog-body {
  flex: 1;
  overflow-y: auto;
  min-height: 0;
  padding-right: 4px;
}

.product-detail-dialog-body::-webkit-scrollbar {
  width: 6px;
}

.product-detail-dialog-body::-webkit-scrollbar-track {
  background: var(--surface-2);
  border-radius: 3px;
}

.product-detail-dialog-body::-webkit-scrollbar-thumb {
  background: var(--surface-3);
  border-radius: 3px;
} `, "",{"version":3,"sources":["webpack://./src/dialogs/ProductDetailDialog.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,OAAO;EACP,gBAAgB;EAChB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;AACpB","sourcesContent":[".product-detail-dialog {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  height: 100%;\n  min-height: 0;\n}\n\n.product-detail-dialog-body {\n  flex: 1;\n  overflow-y: auto;\n  min-height: 0;\n  padding-right: 4px;\n}\n\n.product-detail-dialog-body::-webkit-scrollbar {\n  width: 6px;\n}\n\n.product-detail-dialog-body::-webkit-scrollbar-track {\n  background: var(--surface-2);\n  border-radius: 3px;\n}\n\n.product-detail-dialog-body::-webkit-scrollbar-thumb {\n  background: var(--surface-3);\n  border-radius: 3px;\n} "],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
